import { useEffect, useState } from "react";
import Address from "./components/Address";
import AddressForBuilding from "./components/AddressForBuilding";
import style from "./Form.module.scss";
import PropTypes from "prop-types";
import PersonalInformation from "./components/PersonalInfromations";

function PersonalData({ isModal, person, form, setForm, streets }) {
  const [personalData, setPersonalData] = useState({
    fullName: "",
    CNP: "",
    CIF: "",
    legalRepresentative: "",
    phone: "",
    email: "",
    county: "",
    city: "",
    address: {
      street: "",
      nr: "",
      bl: "",
      sc: "",
      ap: "",
    },
    buildingAddress: {
      number: "",
      city: "",
      sc: "",
      nr: "",
    },
  });

  /**
   *
   */
  useEffect(() => {
    if (Object.keys(form.personalData).length !== 0) {
      setPersonalData(form.personalData);
    }
  }, [form.personalData]);

  /**
   *
   * @param {*} event
   */
  function onChange(event) {
    const newPersonalData = Object.assign({}, personalData);
    const found = event.target.name.includes("_");
    if (found) {
      const address = event.target.name.split("_");
      newPersonalData[address[0]][address[1]] = event.target.value;
      setPersonalData(newPersonalData);
      setForm({ ...form, personalData: newPersonalData });
    } else {
      newPersonalData[event.target.name] = event.target.value;
      setPersonalData(newPersonalData);
      setForm({ ...form, personalData: newPersonalData });
    }
  }

  /**
   *
   * @param {*} event
   * @param {*} newValue
   */
  function handleChangeAddressStreet(event, newValue) {
    let newPersonalData = Object.assign({}, personalData);
    if (newValue) newPersonalData.address.street = newValue;
    else if (event.target.value) {
      newPersonalData.address.street = {
        id: 5,
        label: event.target.value,
      };
    } else
      newPersonalData.address.street = {
        id: "",
        label: "",
      };
    setPersonalData(newPersonalData);
    setForm({ ...form, personalData: newPersonalData });
  }

  function handleChangeAddressForBuildingStreet(event, newValue) {
    let newPersonalData = Object.assign({}, personalData);
    if (newValue) newPersonalData.buildingAddress.sc = newValue;
    else if (event.target.value) {
      newPersonalData.buildingAddress.sc = {
        id: 5,
        label: event.target.value,
      };
    } else
      newPersonalData.buildingAddress.sc = {
        id: "",
        label: "",
      };
    setPersonalData(newPersonalData);
    setForm({ ...form, personalData: newPersonalData });
  }

  return (
    <div style={{ padding: 10 }}>
      <p
        className={
          isModal ? style.personalDataTitleModal : style.personalDataTitle
        }
      >
        Date personale
      </p>
      <PersonalInformation
        personalData={personalData}
        onChange={onChange}
        person={person}
      />
      <Address
        personalData={personalData}
        onChange={onChange}
        streets={streets}
        handleChangeStreet={handleChangeAddressStreet}
        person={person}
      />
      <AddressForBuilding
        personalData={personalData}
        onChange={onChange}
        streets={streets}
        handleChangeStreet={handleChangeAddressForBuildingStreet}
      />
    </div>
  );
}

export default PersonalData;

PersonalData.propTypes = {
  isModal: PropTypes.bool,
  person: PropTypes.object,
  form: PropTypes.object,
  setForm: PropTypes.func,
  streets: PropTypes.object,
};
